import { TableColumn } from "react-data-table-component";
import { TFunction } from "i18next";
import { Badge } from "reactstrap";
import { Eye } from "react-feather";
import { Link } from "react-router-dom";
import { ReceiptDataType } from "../../../../types/reciept/Reciept";

const RecieptAction: React.FC<{ row: ReceiptDataType }> = ({ row }) => {
  return (
    <Link
      to={`${process.env.PUBLIC_URL}/billingpayments/reciept/view/${row.id}`}
      className="cursor-pointer"
    >
      <Eye size={18} />
    </Link>
  );
};

const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case "completed":
      return "success";
    case "pending":
      return "warning";
    case "failed":
    case "cancelled":
      return "danger";
    default:
      return "secondary";
  }
};

export const RecieptListColumn = (
  t: TFunction
): TableColumn<ReceiptDataType>[] => [
  {
    name: t("Sl.No"),
    selector: (row) => row.id,
    sortable: true,
    width: "100px",
  },
  {
    name: t("Invoice No"),
    selector: (row) => row.payment_invoice_no,
    sortable: true,
  },
  {
    name: t("Date"),
    selector: (row) => row.payment_date,
    sortable: true,
  },
  {
    name: t("Amount"),
    selector: (row) => row.payment_amount,
    sortable: true,
  },
  {
    name: t("Payment Type"),
    selector: (row) => row.payment_type,
    sortable: true,
  },
  {
    name: t("Payment Status"),
    cell: (row) => (
      <Badge color={getStatusColor(row.payment_status)}>
        {row.payment_status}
      </Badge>
    ),
    sortable: true,
  },
  {
    name: t("Action"),
    cell: (row) => <RecieptAction row={row} />,
    sortable: true,
  },
];
